import './dynamic-info.css';
import InternationalServices from './international-services/international-services';
import NationalServices from './national-services/national-services';
import AdditionalServices from './additional-services/additional-services';
import Advertisements from './advertisements/advertisements';
import StaticInfo from '../static-info/static-info';
import Banners from './banners/banners';
import MoreAboutAmc from './more-about-amc/more-about-amc';
import DestinationAndCoverage from './destination-and-coverage/destination-and-coverage';

function DynamicInfo() {

  return (
    <>
      <div className='dynamic-info'>

        <div className='banners-content-home'>
          <div className='banners-container'>
            <div className='dynamic-tablet-home'>
              <StaticInfo />
            </div>
            
            <div className='slide-container-home'>
              <Banners />
            </div>
          </div>
          
          <Advertisements />
        </div>

        <MoreAboutAmc />

        <DestinationAndCoverage />

        <NationalServices />
        <InternationalServices />
        <AdditionalServices />
      </div>
    </>
  )
};

export default DynamicInfo;